module.exports = __webpack_public_path__ + "img/ill_spot_ask_box.1ec4fb23.svg";